import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget } from '@eforall/dashboard';
import { PersonVolunteering } from '@interfaces';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { PersonExplorerService } from '../person-explorer.service';
import { getSetup } from "./grid/get-setup";

export interface PersonVolunteeringRow extends PersonVolunteering {
	updatedUTC: number,
}

@Component({
	selector: 'person-volunteering-part',
	standalone: true,
	imports: [
		TabStripModule,
		GridContentWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './person-volunteering.part.html'
})

export class PersonVolunteeringPart {

	#util = inject(UtilityService);
	#dialog = inject(DialogService);
	personExplorer = inject(PersonExplorerService);
	public setup = getSetup(this.#util, this.#dialog);


	public volunteering = computed(() => (this.personExplorer.person.value()?.volunteering ?? []).map(v => ({ ...v, updatedUTC: Date.now() })));
}